import { Box, Button } from "@mui/material";
import DatePicker, { DateObject } from "react-multi-date-picker";
import styled from "@emotion/styled";
import { useEffect, useRef, useState } from "react";

const RequestForm = styled(Box)`
    .rmdp-input {
        background-color: #fcfffd;
        text-align: center;
        height: 3.25rem;
        width: 29ch;
        font-size: 1rem;
        border-radius: 0;
        border: none;
        border-right: none;
        :hover {
            cursor: pointer;
            filter: brightness(95%);
        }

        @media (max-width: 600px) {
            width: 24ch;
        }
    }

    .rmdp-calendar {
        margin: 3px;
    }

    .rmdp-week-day {
        color: #3b3b3b;
    }

    .rmdp-day.rmdp-today > span {
        background-color: #b6d9fd;
        color: black;
        border: 1px solid #3b3b3b;
    }

    .pickerinput {
        background-color: #fcfffd;
    }
    .middleTypography {
        margin-top: auto;
        margin-bottom: auto;
        margin-right: 20px;
        cursor: pointer;
        border: 1px solid #c0c0c0;
    }
    .middleTypography:hover {
        cursor: pointer;
    }
`;

interface RequestDaysComponentParams {
    dateValue: DateObject[] | string[];
    onChangeDateValue: (date: DateObject[]) => void;
}
const RequestDaysComponent = ({
    dateValue,
    onChangeDateValue,
}: RequestDaysComponentParams) => {
    const [isDatePickerOpen, setIsDatePickerOpen] = useState<boolean>(false);
    const datePickerRef = useRef<any>(); // Initialize with null

    const handlePickerChange = (event: DateObject | DateObject[] | null) => {
        if (event === null) {
            onChangeDateValue([]);
        } else if (Array.isArray(event)) {
            onChangeDateValue(event);
        } else {
            onChangeDateValue([event]);
        }

        const selectedDates = Array.isArray(event) ? event : [event];
        const isTwoDatesSelected = selectedDates.length === 2;
        if (isTwoDatesSelected && datePickerRef.current) {
            datePickerRef.current.closeCalendar();
        }
    };

    const handleOpenDatePicker = () => {
        setIsDatePickerOpen(true);
    };

    const handleCloseDatePicker = () => {
        if (dateValue.length != 2 && dateValue.length != 1) {
            setIsDatePickerOpen(false);
        }
    };

    useEffect(() => {
        if (isDatePickerOpen && datePickerRef.current) {
            datePickerRef.current.openCalendar();
        }
    }, [isDatePickerOpen]);

    return (
        <>
            <RequestForm>
                {isDatePickerOpen ? (
                    <DatePicker
                        ref={datePickerRef}
                        className="pickerinput"
                        range
                        format="YYYY-MM-DD"
                        value={dateValue}
                        onChange={handlePickerChange}
                        onClose={handleCloseDatePicker}
                    />
                ) : (
                    <Button
                        className="middleTypography"
                        onClick={handleOpenDatePicker}
                    >
                        {dateValue.toString() != "" ? dateValue.toString() : "Choose Dates"}
                    </Button>
                )}
            </RequestForm>
        </>
    );
};

export default RequestDaysComponent;
